<div class="d-flex flex-row">
    <div class="avatar-wrapper">
        @if (comment.idParent) {
            <div class="parent-line"></div>
        }
        <img [attr.src]="comment.idPlayer | avatarUrl" class="comment-avatar mt-2 mx-2" [attr.alt]="comment.playerDisplayName" />
        @if (comment.replies.length) {
            <div #replyLine class="reply-line"></div>
        }
    </div>

    <div class="d-flex flex-column w-100">
        <div class="card" (mouseenter)="showEmoChooser = true" (mouseleave)="showEmoChooser = false">
            @if (showEmoChooser) {
                <div
                    class="card emo-chooser d-flex flex-row"
                    (mouseenter)="emoChooserMouseOver = true"
                    (mouseleave)="emoChooserMouseOver = false"
                >
                    @for (e of emojies; track e) {
                        <span
                            (mouseenter)="hoveredEmo = e"
                            (mouseleave)="hoveredEmo = null"
                            [class.dimmed]="emoChooserMouseOver && hoveredEmo !== e"
                            (click)="addCommentEmoji(comment.id, e.type)"
                            >{{ e.text }}</span
                        >
                    }
                </div>
            }
            <div class="d-flex flex-column">
                <div class="card-body pb-0">
                    <div class="d-flex">
                        <div class="d-flex flex-row align-items-center">
                            <strong class="player-name">{{ comment.playerDisplayName }}</strong>
                        </div>

                        <div class="ms-auto">
                            @for (e of emojies; track e) {
                                @if (e.count) {
                                    <span [matTooltip]="e.tooltip" class="emo"
                                        >{{ e.text }}<span [class.color-blue]="userReacted(e)" class="num">{{ e.count }}</span></span
                                    >
                                }
                            }
                        </div>
                    </div>
                    @if (editMode) {
                        <app-upsert-comment [idMatch]="comment.idMatch" [comment]="comment" [idParentComment]="comment.idParent">
                        </app-upsert-comment>
                    } @else {
                        <p class="card-text" [class.mb-3]="!comment.attachments.length" [innerHTML]="comment.text | preserveNewline"></p>
                    }
                    @if (comment.imageUrl) {
                        <img [src]="comment.imageUrl" class="mb-1 card-img-top comment-img" [alt]="comment.imageUrl" alt="giph" />
                    }
                </div>
            </div>
            @if (comment.attachments.length && !editMode) {
                <div class="row m-2">
                    @for (attachment of comment.attachments; track attachment) {
                        <app-comment-attachment
                            [attachment]="attachment"
                            [ngClass]="{
                                'col-lg-6': attachment.contentType.startsWith('image') && comment.attachments.length !== 1,
                                'col-lg-12': attachment.contentType.startsWith('video') || comment.attachments.length === 1,
                            }"
                        ></app-comment-attachment>
                    }
                </div>
            }
            @if (showReply) {
                <app-upsert-comment
                    [style.margin-left.px]="level() * 30"
                    [idMatch]="comment.idMatch"
                    [idParentComment]="comment.id"
                    [focusOnInit]="true"
                    (sent)="showReply = false"
                    class="m-2"
                ></app-upsert-comment>
            }
        </div>
        <div class="d-flex flex-row justify-content-between p-1 player-name">
            <div class="d-flex flex-row gap-2">
                @if (level() < 2) {
                    <span class="text-muted clickable" (click)="onReplyCommentClick()">{{ 'MATCH_BOX.COMMENT_REPLY' | translate }}</span>
                }
                @if (comment.idPlayer === idPlayer) {
                    <span class="text-muted clickable" (click)="onEditCommentClick()">{{ 'MATCH_BOX.COMMENT_EDIT' | translate }}</span>
                }
                @if (comment.idPlayer === idPlayer && comment.replies.length === 0) {
                    <span class="text-muted clickable" [swal]="deleteCommentSwal">{{ 'MATCH_BOX.COMMENT_DELETE' | translate }}</span>
                }
                <swal
                    #deleteCommentSwal
                    (confirm)="deleteComment(comment.id)"
                    [title]="'MATCH_BOX.DELETRE_COMMENT_SWAL_TTITLE' | translate"
                    [showCancelButton]="true"
                    [focusConfirm]="true"
                    [backdrop]="false"
                    icon="question"
                >
                </swal>
            </div>

            <span class="text-muted player-name" [matTooltip]="comment.createdAt | luxon: 'DATETIME_SHORT'">{{
                comment.createdAt | luxon: 'fromNow'
            }}</span>
        </div>

        @for (reply of comment.replies; track reply; let last = $last) {
            <app-comment #childComment [comment]="reply" [level]="level() + 1"></app-comment>
        }
    </div>
</div>
